// Phase 47 — Frontend mirror of `backend/services/shipment_statuses.py`.
// Kept as a plain module so any component (Admin table, tracking timeline,
// delivery page) can look up labels/badges/icons without duplicating strings.

import {
  Clock,
  Package,
  PackageCheck,
  Truck,
  Anchor,
  Ship,
  FileCheck,
  Route,
  CheckCircle,
  XCircle,
} from "lucide-react";

// Ordered list — matches backend ORDER (excludes legacy `en_transito`).
export const SHIPMENT_STATUS_ORDER = [
  "pendiente",
  "confirmado_pendiente_recogida",
  "recogido",
  "en_puerto_almeria",
  "en_puerto_oran",
  "en_aduanas",
  "camino_campamentos",
  "reparto",
  "entregado",
  "cancelado",
];

export const SHIPMENT_STATUS_LABELS = {
  pendiente: "Pendiente",
  pendiente_pago: "Pendiente de pago",
  confirmado_pendiente_recogida: "Confirmado — pendiente de recogida",
  recogido: "Recogido",
  en_transito: "En tránsito", // legacy — still rendered for old rows
  en_puerto_almeria: "En puerto de Almería",
  en_puerto_oran: "En puerto de Orán",
  en_aduanas: "En aduanas",
  camino_campamentos: "Camino hacia los campamentos",
  reparto: "En reparto",
  entregado: "Entregado",
  cancelado: "Cancelado",
};

export const SHIPMENT_STATUS_BADGE_CLASSES = {
  pendiente: "bg-amber-100 text-amber-800",
  pendiente_pago: "bg-neutral-200 text-neutral-700",
  confirmado_pendiente_recogida: "bg-amber-100 text-amber-800",
  recogido: "bg-blue-100 text-blue-800",
  en_transito: "bg-indigo-100 text-indigo-800",
  en_puerto_almeria: "bg-blue-100 text-blue-800",
  en_puerto_oran: "bg-sky-100 text-sky-800",
  en_aduanas: "bg-orange-100 text-orange-800",
  camino_campamentos: "bg-violet-100 text-violet-800",
  reparto: "bg-amber-100 text-amber-800",
  entregado: "bg-emerald-100 text-emerald-800",
  cancelado: "bg-red-100 text-red-800",
};

export const SHIPMENT_STATUS_ICONS = {
  pendiente: Clock,
  confirmado_pendiente_recogida: PackageCheck,
  recogido: Package,
  en_transito: Truck,
  en_puerto_almeria: Anchor,
  en_puerto_oran: Ship,
  en_aduanas: FileCheck,
  camino_campamentos: Truck,
  reparto: Route,
  entregado: CheckCircle,
  cancelado: XCircle,
};

/** Return the human-readable Spanish label, falling back to the raw code. */
export function shipmentStatusLabel(status) {
  return SHIPMENT_STATUS_LABELS[status] || status;
}
